import { render, staticRenderFns } from "./Trailers.vue?vue&type=template&id=680dcc2c&scoped=true&"
import script from "./Trailers.vue?vue&type=script&lang=js&"
export * from "./Trailers.vue?vue&type=script&lang=js&"
import style0 from "./Trailers.vue?vue&type=style&index=0&id=680dcc2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680dcc2c",
  null
  
)

export default component.exports